export class UserRecord {
    id: number;
    uuid: string;
    firstName: string;
    lastName: string;
    email: string;
    emailConfirmed: boolean = false;
    country: string = null;
    state: string = null;
    city: string = null;
    address: string = null;
    zip: string = null;
    active: boolean = true;
    admin: boolean = false;
    data: any = {};

    constructor(data:Partial<UserRecord>={}) {
        Object.assign(this, data);
    }
}